module.exports = __webpack_public_path__ + "static/13-09ab42ba77ad82d707e21c22d5046257.jpg";